import { useMemo } from 'react'

import {
  type FilterListShort,
  useListListsQuery,
} from '@/legacy-api/filter-lists-slice.gen'

export type FilterListsMap = Record<string, FilterListShort>

/** Changes when a list is created, deleted or gets a new version. */
export function filterListsVersionKey(filterListsMap: FilterListsMap): string {
  return Object.values(filterListsMap)
    .map((list) => `${list.list_id}:${list.version}`)
    .join(',')
}

export function useGetFilterListsMap() {
  const { data, isLoading, error } = useListListsQuery()

  const filterListsMap = useMemo<FilterListsMap>(() => {
    if (!data?.data) return {}

    return data.data.reduce<FilterListsMap>((acc, list) => {
      acc[list.list_id] = list
      return acc
    }, {})
  }, [data?.data])

  return { filterListsMap, isLoading, error }
}
